import { ValidationRuleSchema } from 'vee-validate/dist/types/types'

const Zip: ValidationRuleSchema = {
  validate(value: string) {
    return /^\d{3}-\d{4}$/.test(value)
  },
}

export default Zip
